import { StyleProps, useIsMobileView } from 'deepstash-ui';
import React, { useMemo } from 'react';
import { HeadingSize } from 'types/globalTypes';
import { Source } from 'types/models';
import {
  SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_DESKTOP,
  SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_MOBILE,
} from 'utils/constants';
import BaseSourceTitle from '../BaseSourceTitle';
import { InfoLinkWrapper } from '../InfoLinkWrapper';
import SourceImageV2 from '../source-image/SourceImageV2';
import SourceDomain from '../SourceDomain';
import { SourceTitleByTypeSize } from '../SourceTitleByType';

interface SourceBookTitleProps {
  source: Source;
  titleHeadingSize: 'p' | HeadingSize;
  /**
   * the size for the BookCover
   */
  size?: SourceTitleByTypeSize;
  withLink?: boolean;
  /**
   * Wether to have a static sourceTitle that is not interactable
   */
  isNotInteractable?: boolean;
  preload?: boolean;
  titleOverride?: string;
}

const SourceBookTitle: React.FC<SourceBookTitleProps & StyleProps> = ({
  source,
  size,
  withLink,
  isNotInteractable,
  preload,
  titleOverride,
  ...props
}) => {
  const isMobileView = useIsMobileView();

  const leftItem = useMemo(
    () => (
      <SourceImageV2
        source={source}
        size={
          isMobileView
            ? SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_MOBILE
            : SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_DESKTOP
        }
        isNotInteractable={isNotInteractable}
        preload={preload}
      />
    ),
    [size, source, isNotInteractable, isMobileView],
  );

  const mainTitle = titleOverride ?? source.title;
  const subTitle = useMemo(
    () => (
      <SourceDomain
        domain={source.author ? `by ${source.author}` : 'Unknown Author'}
        size={size}
        hasExternalSvg={false}
        isNotInteractable={isNotInteractable}
      />
    ),
    [size, source, isNotInteractable],
  );

  return (
    <InfoLinkWrapper
      source={source}
      withLink={withLink}
      isNotInteractable={isNotInteractable}
    >
      <BaseSourceTitle
        mainTitle={mainTitle}
        subTitle={subTitle}
        leftItem={leftItem}
        size={size}
        source={source}
        {...props}
      />
    </InfoLinkWrapper>
  );
};
export default SourceBookTitle;
